import { DateTime } from 'luxon';
import firebase from 'firebase/compat/app';

import aguid from 'lib/aguid';

import { DASHBOARDS_COLLECTION } from '../constants';
import withoutNulls from './search/withoutNulls';
import { CurrentUserContextType } from '../contexts/CurrentUserContext';
import {
  migrateDashboardIsV3Published,
  migrateDashboardV3Access,
} from '../screens/Settings/Advanced/V3Migrators/ContentV3AccessMigrator/utils';

const createDashboard = async ({
  currentUser,
  name,
  isTemplate,
  access,
  accountRef,
  wallboard,
  isMarkedAsSEOnly,
  isAutoHideBottomBar,
  isV3,
  labelIds,
}: {
  currentUser: CurrentUserContextType;
  name: string;
  isTemplate?: boolean;
  access: ResourceAccess;
  accountRef: firebase.firestore.DocumentReference;
  wallboard?: Wallboard;
  isMarkedAsSEOnly?: boolean;
  isAutoHideBottomBar?: boolean;
  isV3: boolean;
  labelIds: string[];
}) => {
  let newDashboard: DashboardType = {
    version: '5' as '5',
    id: aguid(),
    name,
    canvas: {
      cards: [],
    },
    variableDrillDowns: [],
    isTemplate: !!isTemplate,
    createdBy: currentUser.id,
    updatedBy: currentUser.id,
    createdOn: DateTime.utc().toISO(),
    updatedOn: DateTime.utc().toISO(),
    access,
    isMarkedAsSEOnly,
    isAutoHideBottomBar,
    labelIds,
    v3Access: {
      isPublic: false,
      groupIds: [],
      userIds: [],
    },
    isV3Published: false,
  };
  if (!isV3) {
    newDashboard.isV3Published = migrateDashboardIsV3Published(newDashboard);
    newDashboard.v3Access = migrateDashboardV3Access(newDashboard);
  }

  if (wallboard) {
    newDashboard.isWallboardSlide = true;
    newDashboard.wallboardId = wallboard.id;
  }

  await (accountRef as any)
    .collection(DASHBOARDS_COLLECTION)
    .doc(newDashboard.id)
    .set(withoutNulls(newDashboard));
  return {
    newDashboardId: newDashboard.id,
    newDashboard,
  };
};

export default createDashboard;
